import { httpGetAsync } from "./requestService";


export const getAsync = async (saleYear) => {
    const url = `${process.env.VUE_APP_BACKEND_API_URL}/dashboard?year=${saleYear}`;
    const resp = await httpGetAsync(url);

    return resp.data;
}